import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalControlService } from 'src/app/services/modal-control.service';


@Component({
  selector: 'app-pre-processing-tool',
  templateUrl: './pre-processing-tool.component.html',
  styleUrls: ['../../../../app.component.scss'],
  standalone: false
})
export class PreProcessingToolComponent implements OnInit {

  decimate : boolean = false;

  @Input()
  fileFormat: string;

  @Input()
  file: File
  constructor(
    private modalService: ModalControlService,
    public bsModalRef : BsModalRef,
  ) { }

  ngOnInit(): void {
  }

  cancelPreProcessingTool():void {
    this.bsModalRef.hide();
  }

  changeDecimate():void{
    this.decimate = !this.decimate;
  }

}
